import '../build/modernizr';
import './supportedbrowser';

export default window.Modernizr;
